import { render, staticRenderFns } from "./reproducibility-companion-papers.vue?vue&type=template&id=db6339e0&scoped=true&"
import script from "./reproducibility-companion-papers.vue?vue&type=script&lang=js&"
export * from "./reproducibility-companion-papers.vue?vue&type=script&lang=js&"
import style0 from "./reproducibility-companion-papers.vue?vue&type=style&index=0&id=db6339e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6339e0",
  null
  
)

export default component.exports